export enum StopEventTypes {
  Actual,
  Appointment,
  Arrival,
  Departure,
  Estimate,
}
